import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Desktop, Mobile, useTracking } from "@edreamsodigeo/frontend-core";
import useGetActionsFromUrl from "../../clientSide/hooks/useGetActionsFromUrl/useGetActionsFromUrl";
import { useGetSuccessAuthRedirection } from "../../clientSide/hooks/useGetSuccessAuthRedirection";
import MyTripsLoginDesktopContainer from "./MyTripsLoginDesktopContainer";
import MyTripsLoginMobileContainer from "./MyTripsLoginMobileContainer";
import { USER_STATUS } from "../../types/tripLoginTypes";
const MyTripsLoginContainer = ({
  userAuthentication = null,
  incentivizeUserAuthentication = null,
  loginProps
}) => {
  const redirectionUrl = useGetSuccessAuthRedirection();
  const {
    status
  } = loginProps?.user || {};
  const {
    trackPage
  } = useTracking();
  const isLogged = status => {
    return status === USER_STATUS.LOGGED;
  };
  useEffect(() => {
    if (isLogged(status)) {
      window.location.assign(redirectionUrl);
    }
  }, [status, redirectionUrl]);
  useEffect(() => {
    trackPage("mytripslogin", {
      funnel: false
    });
  }, [trackPage]);
  const action = useGetActionsFromUrl();
  const hasWelcomeSupportAreaBanner = action === "opensa";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(MyTripsLoginDesktopContainer, {
    hasWelcomeSupportAreaBanner: hasWelcomeSupportAreaBanner,
    userAuthentication: userAuthentication,
    incentivizeUserAuthentication: incentivizeUserAuthentication
  })), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(MyTripsLoginMobileContainer, {
    hasWelcomeSupportAreaBanner: hasWelcomeSupportAreaBanner,
    userAuthentication: userAuthentication,
    incentivizeUserAuthentication: incentivizeUserAuthentication
  })));
};
MyTripsLoginContainer.propTypes = {
  loginProps: PropTypes.shape({
    user: PropTypes.shape({
      status: PropTypes.string
    })
  }),
  userAuthentication: PropTypes.element,
  incentivizeUserAuthentication: PropTypes.element
};
export default MyTripsLoginContainer;